import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from '@core/contexts/AuthContext'
import { SudoProvider } from '@core/contexts/SudoContext'  // SEC-B4 — sudo mode global
import { ToastProvider } from '@core/components/Toast'
import SudoModal from '@core/components/SudoModal'  // SEC-B4 — modal de re-auth global
// SEC-F0.5 — Inter font self-hosteada (antes en fonts.googleapis.com).
// Cada peso se importa explícito; Vite los bundlea con hash y los sirve desde
// el propio dominio (sin CDN externo, sin necesidad de SRI, mejor privacidad).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import './index.css'
// i18n setup (Bombai Fase 2f) — debe inicializarse antes de cualquier componente.
import '@core/i18n'
// Exponer seed de roles default en window (admin puede invocar __seedRolesDefault desde consola)
import '@core/lib/seedRoles'
// Exponer registro de módulos y helper puedeHacer() en window
import '@core/lib/modulos'
import '@core/lib/permisos'
// Exponer helpers de asignaciones (ABM de tiposAsignacion + crear)
import '@core/lib/asignaciones'
// Exponer helpers de notificaciones (Fase 4.5)
import '@core/lib/notificaciones'
// Extensiones de mensajería: convertir un mensaje (o una selección) en tarea (Fase 4)
import '@core/lib/mensajesExtensiones'
// Flujo extendido de accionables: aceptar/rechazar/transferir/escalar (Fase 5)
import '@core/lib/tareas'
// SLAs: ABM + motor de evaluación (Fase 5.5)
import '@core/lib/slas'
// Catálogo de tipos de tarea + resolución de SLA (Fase 7)
import '@core/lib/tiposTarea'
// Mapeo secciones de dashboard → tipos de tarea (admin: __mapeoTareas desde consola)
import '@core/lib/mapeoTareas'
// Migración: unificar accionables + asignaciones en empresas/{empId}/tareas
import '../scripts/migracion-tareas-unificadas'
// Seed del catálogo de tipos de tarea (admin: __seedTiposTarea() desde consola)
import '../scripts/seed-tipos-tarea'
// Seed canónico verbo+elemento + migración legacy (admin: __seedTiposTareaCanonicos / __seedMapeoSeccionesTareas)
// Postventa MVP F3 — ver docs/modelo-tareas.md.
import '@core/lib/seedTiposTarea'
// Seed del catálogo de agentes (admin: __seedAgentes() desde consola)
import '@core/lib/seedAgentes'
// Seed del catálogo de tipos de caso + categorías (admin: __seedTiposCaso() desde consola)
import '../scripts/seed-tipos-caso'
// Seed v2 del catálogo de roles (admin: __seedRolesV2() desde consola) — B1 plan v2
import '../scripts/seed-roles-v2'
// Migración B2: /accesos → /asignaciones v2 + asegurar Wizard de Mariano
// Exponen: __asegurarWizardMariano, __migrateAccesosAAsignacionesV2, __verificarAsignaciones
import '../scripts/migrate-accesos-a-asignaciones-v2'
// Migración B3: usuarios → rolId + completar /asignaciones + cache derivado
// Exponen: __migrateUsuariosV2, __verificarMigracionUsuariosV2, __verificarMariano
import '../scripts/migrate-usuarios-v2'
// Librería core del módulo Casos (admin: __casos, __tiposCaso desde consola)
import '@core/lib/casos'
import '@core/lib/tiposCaso'
// B6 — Reglas, macros, plantillas (admin: __reglasCaso, __macrosCaso, __plantillasCaso)
import '@core/lib/reglasCaso'
import '@core/lib/macrosCaso'
import '@core/lib/plantillasCaso'
// B7 — Aprendizajes de caso / KCS (admin: __aprendizajesCaso)
import '@core/lib/aprendizajesCaso'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SudoProvider>
          <ToastProvider>
            <App />
            <SudoModal />
          </ToastProvider>
        </SudoProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
